"use client"

import { useEffect, useRef } from "react"

import { ConsentQuoteType, postAdsConsent } from "@/app/endpoints/consentEndpoints"
import { onAdsConsentChange } from "@/app/utils/ads-consent"

/** Persiste le choix du bandeau dès qu'un lead existe, puis à chaque changement d'avis. Aucun rendu. */
export function useAdsConsentSync(quoteToken: string | null | undefined, quoteType: ConsentQuoteType): void {
    const sent = useRef<string | null>(null)

    // abonnement dès le montage : le choix est souvent exprimé avant que le devis existe, et reste mémorisé jusque-là
    useEffect(() => {
        return onAdsConsentChange((status) => {
            if (!quoteToken) return

            const key = `${quoteToken}|${status}`
            if (sent.current === key) return

            sent.current = key
            // un envoi échoué ne doit pas condamner le choix : rouvrir la clé pour qu'un évènement suivant réessaie
            void postAdsConsent(quoteToken, quoteType, status).then((persisted) => {
                if (!persisted && sent.current === key) sent.current = null
            })
        })
    }, [quoteToken, quoteType])
}
